import React from "react";
import { Stack } from "@mui/system";

import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";


export default function Dipm(){

  return(

    <>
    <Helmet title="Apoio à Pesquisa Mineral - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="APOIO À PESQUISA MINERAL" link1={"Projetos/ "} link2={"APOIO À PESQUISA MINERAL"} />
      <section id="context">
        <div className="container">
        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2>Apoio à Pesquisa Mineral</h2>
                <p>
                  Prestação de serviços de apoio à pesquisa geológica a serem executados nas áreas internas e externas de interesse da Vale, compreendendo serviços de geologia e infraestrutura, em toda a região de Carajás – PA, em um raio de atuação de 500Km de Parauapebas – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info">
                <h2>Informações do Projeto</h2>
                <ul>
                  <li><strong>Cliente: </strong> Vale</li>
                  <li><strong>Cidade: </strong> Parauapebas - PA </li>
                  <li><strong>Ano: </strong> 2016 </li>
                  <li><strong>Segmento: </strong> Geologia </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />


      <Ouvidoria/>
    </>
  )
}